import useTranslation from '../../hooks/useTranslation';
import { useSelector } from 'react-redux';
import timeFormAPI from '../../api/ui/timeFormAPI';
import { useEffect, useState } from 'react';
import { create } from './table-schema';
import {getGradeIcon, getCarType} from '../../constants/nft';

function useSchemaDisassembleLog() {
  const { t } = useTranslation();
  const locale = useSelector((state) => state.language.locale);

  /**
   * 테이블 헤더에 표시할 항목 문자열 배열
   */
  const headerKeys = [
    'admin.log.perplay.disassemble.table.head.no', // "로그 번호",
    'admin.log.perplay.disassemble.table.head.user', // "유저 ID",
    'admin.log.perplay.disassemble.table.head.nft', // "NFT UID",
    'admin.log.perplay.disassemble.table.head.grade', // "NFT 등급",
    'admin.log.perplay.disassemble.table.head.type', // "NFT 종류",
    'admin.log.perplay.disassemble.table.head.level', // "NFT 레벨",
    'admin.log.perplay.disassemble.table.head.sigil', // "NFT 인장",
    'admin.log.perplay.disassemble.table.head.tran', // "트랜잭션 번호",
    'admin.log.perplay.disassemble.table.head.time', // "분해 시각",
  ];

  /**
   * 서버로부터 전달받은 request를 테이블에 표시할 내용으로 변환한다.
   *
   * 오브젝트 키는 param1, param10 등의 형식으로 param 다음에 숫자를 붙여서 사용한다.
   *
   * param1은 헤더의 첫번째 표시되는 항목이다.
   *
   * 헤더에는 표시되지 않지만 상세에 표시될 항목의 경우 headSize 이후의 숫자를 사용한다.
   *
   * key는 반드시 있어야 한다.
   * @param {object} row
   * @returns
   */
  const parse = (row) => {
    const no = row?.disassembleNo || 0;
    const account = row?.accountNo || '';
    const nft = row?.nftUid || 0;
    const grade = getGradeIcon(row?.nftGrade);
    const type = getCarType(row?.nftType);
    const level = row?.nftLevel || 0;
    const sigil = row?.nftSeal || 'None';
    const tran = row?.walletTransactionNo || 0;
    const time = timeFormAPI.changeDataLog(row?.createdAt);

    return {
      key: no,
      param1: no,
      param2: account,
      param3: nft,
      param4: grade,
      param5: type,
      param6: level,
      param7: sigil,
      param8: tran,
      param9: time,
    };
  };

  /**
   * 로그 데이터를 클릭했을 때 보여줄 디테일 다이얼로그에 보여줄 항목을 작성한다.
   *
   * 입력값인 row는 위의 parse에서 변환된 값이다.
   *
   * @param {object} row
   * @returns
   */
  const details = (row) => {
    const array = [];
    if (row) {
      //
    }
    return array;
  };

  const [schema, setSchema] = useState();

  useEffect(() => {
    const headers = headerKeys.map((key) => t(key));
    const schema = create({
      heads: headers,
      parseFunc: parse,
      detailFunc: details,
    });
    setSchema(schema);
  }, [locale]);

  return { schema: schema };
}

export default useSchemaDisassembleLog;
